import React from 'react';
import { CouponView, Flex, IconDownload } from '@banhala/ui-kit';
import { useGoodsCouponListBottomSheet } from './components/GoodsCouponListBottomSheet';
import { useGoodsCoupon } from '../../queries/useGoodsCoupon';
import { isNil } from 'shared/src/utils';
import { parseCtaDescription } from './utils/parseCtaDescription';
import { useLogClickCouponList } from './hooks/useLogClickCouponList';
import { useGoodsCouponList } from './queries/useGoodsCouponList';

export const CouponListBanner: React.FC = () => {
  const { data: goodsCoupon } = useGoodsCoupon();
  const { show: showGoodsCouponListBottomSheet } =
    useGoodsCouponListBottomSheet();
  const logClickLogCouponList = useLogClickCouponList(
    goodsCoupon?.coupon ?? null,
    goodsCoupon?.is_exist_usable_coupons,
  );

  const { data: coupons } = useGoodsCouponList();

  if (isNil(goodsCoupon)) return null;

  if (isNil(coupons) || coupons.allCoupons.length === 0) return null;

  return (
    <Flex.Center flex={1} padding={{ bottom: 20 }} testID={`쿠폰받기버튼`}>
      <CouponView
        title={
          isNil(goodsCoupon.coupon) ? '내가 받은 쿠폰 보기' : '할인 쿠폰 받기'
        }
        icon={<IconDownload size={20} />}
        onPress={() => {
          logClickLogCouponList();
          showGoodsCouponListBottomSheet();
        }}
        description={
          goodsCoupon.coupon_cta_info
            ? parseCtaDescription(goodsCoupon.coupon_cta_info?.cta_description)
            : undefined
        }
      />
    </Flex.Center>
  );
};
